(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/detail-view-mobile-handler/assets/javascripts/detail-view-mobile-handler.js') >= 0) return;  svs.modules.push('/components/tipsen/detail-view-mobile-handler/assets/javascripts/detail-view-mobile-handler.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useCallback = _React.useCallback,
  useRef = _React.useRef;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const EventTypeField = svs.components.sportinfo.common.constants.EventTypeField;
const getSportInfoMatchState = svs.components.sportinfo.common.matchState.getSportInfoMatchState;
const BigStatBanner = svs.components.sportInfo.bigStatBanner.BigStatBanner;
const _svs$components$tipse = svs.components.tipsen.tipsenModal,
  TipsenModal = _svs$components$tipse.TipsenModal,
  StickyBottom = _svs$components$tipse.StickyBottom,
  StickyButtonClose = _svs$components$tipse.StickyButtonClose,
  ModalHeader = _svs$components$tipse.ModalHeader,
  StickyNavLink = _svs$components$tipse.StickyNavLink;
const useQueryParam = svs.components.lbUtils.useQueryParam;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory,
  useLocation = _ReactRouterDOM.useLocation,
  Route = _ReactRouterDOM.Route,
  useRouteMatch = _ReactRouterDOM.useRouteMatch,
  Switch = _ReactRouterDOM.Switch;
const _svs$components$sport = svs.components.sportinfo.matchInfoRedux.selectors,
  selectSportEvent = _svs$components$sport.selectSportEvent,
  selectEventStatisticCurrentValueByType = _svs$components$sport.selectEventStatisticCurrentValueByType;
const useBetEvent = svs.components.sportinfo.matchInfoHooks.useBetEvent;
const _svs$components$tipse2 = svs.components.tipsen.hooks,
  useBranding = _svs$components$tipse2.useBranding,
  useGetParticipantsByEvent = _svs$components$tipse2.useGetParticipantsByEvent;
const _svs$components$tipse3 = svs.components.tipsen.drawProvider.hooks,
  useCurrentDrawEvent = _svs$components$tipse3.useCurrentDrawEvent,
  useCurrentDraw = _svs$components$tipse3.useCurrentDraw;
const _svs$components$tipse4 = svs.components.tipsen.sideNav,
  LazyGameGuide = _svs$components$tipse4.LazyGameGuide,
  LazyOdds = _svs$components$tipse4.LazyOdds;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const ItemsMenu = svs.ui.ReactItemsMenu.ItemsMenu;
const LinkItemRoute = svs.components.lbUtils.linkItemRoute.LinkItemRoute;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const baseUrl = svs.core.data.baseUrl;
const getProductBrandByDraw = svs.components.lbUtils.brandMapping.fn.getProductBrandByDraw;
const useCloseModal = () => {
  const history = useHistory();
  const location = useLocation();
  const handleClose = () => {
    const search = new URLSearchParams(location.search);
    if (search.has('openStatistic')) {
      search.delete('openStatistic');
    }
    history.push({
      search: "?".concat(search)
    });
  };
  return handleClose;
};
const ModalFooter = _ref => {
  let routesMatch = _ref.routesMatch;
  return React.createElement(StickyBottom, null, React.createElement(StickyButtonClose, {
    to: {
      pathname: routesMatch.url
    }
  }));
};
const DetailsStickyBottom = _ref2 => {
  let closeModal = _ref2.closeModal,
    eventNumber = _ref2.eventNumber,
    numberOfEventsInCoupon = _ref2.numberOfEventsInCoupon;
  const pathname = location.pathname.replace(baseUrl, '');
  const currentSearchParams = new URL(window.location.href).searchParams;
  const searchParamsNextEvent = new URLSearchParams(currentSearchParams);
  const nextEventNumber = eventNumber === numberOfEventsInCoupon ? 1 : eventNumber + 1;
  searchParamsNextEvent.set('event', nextEventNumber);
  const searchParamsPrevioustEvent = new URLSearchParams(currentSearchParams);
  const previousEventNumber = eventNumber === 1 ? numberOfEventsInCoupon : eventNumber - 1;
  searchParamsPrevioustEvent.set('event', previousEventNumber);
  return React.createElement(StickyBottom, {
    hasEvenplacement: false
  }, React.createElement(StickyNavLink, {
    ariaLabel: "G\xE5 till match ".concat(previousEventNumber),
    icon: "menu-left",
    pathname: pathname,
    searchParams: searchParamsPrevioustEvent
  }), React.createElement(StickyButtonClose, {
    "aria-label": "Tillbaka till kupong",
    isInverted: false,
    isTransparent: true,
    onClick: closeModal
  }), React.createElement(StickyNavLink, {
    ariaLabel: "G\xE5 till match ".concat(nextEventNumber),
    icon: "menu-right",
    pathname: pathname,
    searchParams: searchParamsNextEvent
  }));
};
const defaultSportEvent = {
  participants: [],
  leagueId: undefined,
  matchStart: undefined
};
const gameGuidePaths = ["/".concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.SYSTEM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_SM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.TIPS_EM, "/").concat(TipsenModuleGameUrl.GAME_GUIDE), "/".concat(TipsenModuleGameUrl.SINGLES, "/").concat(TipsenModuleGameUrl.GAME_GUIDE)];
const oddsPaths = ["/".concat(TipsenModuleGameUrl.ODDS)];
const DetailViewMobileHandler = _ref3 => {
  let drawId = _ref3.drawId,
    _ref3$hasMaskedOutcom = _ref3.hasMaskedOutcomes,
    hasMaskedOutcomes = _ref3$hasMaskedOutcom === void 0 ? false : _ref3$hasMaskedOutcom,
    headerComponent = _ref3.headerComponent,
    extraMenuItems = _ref3.extraMenuItems,
    children = _ref3.children;
  const _useCurrentDraw = useCurrentDraw(drawId),
    drawEvents = _useCurrentDraw.drawEvents,
    productId = _useCurrentDraw.productId,
    drawNumber = _useCurrentDraw.drawNumber;
  const _useCurrentDrawEvent = useCurrentDrawEvent(drawId),
    eventNumber = _useCurrentDrawEvent.eventNumber,
    matchId = _useCurrentDrawEvent.matchId;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const routesMatch = useRouteMatch();
  const sportEvent = useSelector(state => selectSportEvent(state, matchId)) || defaultSportEvent;
  const _useBetEvent = useBetEvent({
      productId,
      drawNumber,
      eventNumber
    }),
    eventStatisticsKey = _useBetEvent.eventStatisticsKey;
  const odds = useSelector(state => selectEventStatisticCurrentValueByType(state, eventStatisticsKey, EventTypeField.Odds));
  const league = useSelector(state => state.Leagues[sportEvent.leagueId]);
  const _useGetParticipantsBy = useGetParticipantsByEvent(productId, drawNumber, eventNumber),
    _useGetParticipantsBy2 = _slicedToArray(_useGetParticipantsBy, 2),
    homeParticipant = _useGetParticipantsBy2[0],
    awayParticipant = _useGetParticipantsBy2[1];
  const history = useHistory();
  const location = useLocation();
  const modalRef = useRef();
  const shouldOpenStatistic = Boolean(useQueryParam('openStatistic') !== null);
  const closeModal = useCloseModal();
  const results = sportEvent === null || sportEvent === void 0 ? void 0 : sportEvent.result[0];
  const onNavigateNext = useCallback(next => {
    const maxMatchCount = drawEvents.length;
    let nextEventNumber = eventNumber + next;
    if (nextEventNumber < 1) {
      nextEventNumber = maxMatchCount;
    } else if (nextEventNumber > maxMatchCount) {
      nextEventNumber = 1;
    }
    const search = new URLSearchParams(location.search);
    if (search.has('openStatistic')) {
      search.set('event', nextEventNumber);
    }
    history.replace({
      search: "?".concat(search)
    });
    modalRef.current.scrollTo(0, 0);
  }, [eventNumber, location.search, history, drawEvents.length]);
  if (extraMenuItems.length > 0) {
    extraMenuItems.forEach(item => {
      if (item.to.search.length) {
        item.to.search += '&openStatistic=';
      } else {
        item.to.search += 'openStatistic=';
      }
    });
  }
  const matchState = getSportInfoMatchState(sportEvent.sportEventStatus);
  const classNames = ['pg_detail_header', "pg_detail_header--".concat(branding)];
  const detailViewClassNames = ['pg_detail_view__menu'];
  if (hasMaskedOutcomes) {
    classNames.push('pg_detail_header--hidden');
    detailViewClassNames.push('pg_detail_view__menu--hidden');
  }
  return React.createElement(React.Fragment, null, React.createElement(TipsenModal, {
    Bottom: () => React.createElement(DetailsStickyBottom, {
      closeModal: closeModal,
      eventNumber: eventNumber,
      numberOfEventsInCoupon: drawEvents === null || drawEvents === void 0 ? void 0 : drawEvents.length,
      onNavigateNext: onNavigateNext
    }),
    isOpen: shouldOpenStatistic,
    ref: modalRef,
    scrollToEventOnClose: true
  }, React.createElement(BigStatBanner, {
    awayTeam: awayParticipant,
    className: classNames.join(' '),
    eventNumber: eventNumber,
    homeTeam: homeParticipant,
    leagueName: league === null || league === void 0 ? void 0 : league.name,
    matchId: matchId,
    matchState: matchState,
    odds: {
      one: odds[0],
      x: odds[1],
      two: odds[2]
    },
    productId: productId,
    results: results,
    sportEventStatus: sportEvent.sportEventStatus,
    sportType: league === null || league === void 0 ? void 0 : league.sportType,
    startTime: sportEvent.matchStart
  }), headerComponent && React.createElement("div", {
    className: "pg_detail_view__bet-buttons pg_detail_view__bet-buttons--".concat(branding)
  }, headerComponent), extraMenuItems.length && React.createElement("div", {
    className: detailViewClassNames.join(' ')
  }, React.createElement(ItemsMenu, {
    branding: "side-nav",
    className: "tipsen-side-nav-menu"
  }, extraMenuItems.map(_ref4 => {
    let icon = _ref4.icon,
      selectedOnPaths = _ref4.selectedOnPaths,
      to = _ref4.to,
      label = _ref4.label,
      testIdSuffix = _ref4.testIdSuffix;
    return React.createElement(LinkItemRoute, {
      Component: TipsenLink,
      "data-testid": "detail-view-mobile-".concat(testIdSuffix),
      icon: icon,
      iconPosition: "left",
      key: to.pathname,
      label: label,
      selectedOnPaths: selectedOnPaths,
      to: to
    });
  }))), React.createElement(Switch, null, extraMenuItems.filter(_ref5 => {
    let to = _ref5.to;
    return to.pathname.length > 0;
  }).map(_ref6 => {
    let to = _ref6.to,
      className = _ref6.className,
      Component = _ref6.Component,
      _ref6$props = _ref6.props,
      props = _ref6$props === void 0 ? {} : _ref6$props;
    let absolutePath;
    if (routesMatch.path === '/') {
      absolutePath = to.pathname;
    } else {
      absolutePath = "".concat(routesMatch.path).concat(to.pathname);
    }
    return React.createElement(Route, {
      key: to.pathname,
      path: absolutePath
      ,
      render: () => React.createElement(Component, _extends({
        branding: branding,
        className: className
      }, props))
    });
  }), children)), React.createElement(Route, {
    path: gameGuidePaths,
    render: _ref7 => {
      let match = _ref7.match;
      return React.createElement(TipsenModal, {
        Bottom: () => React.createElement(ModalFooter, {
          routesMatch: routesMatch
        }),
        isOpen: Boolean(match)
      }, React.createElement(ModalHeader, null, "Spelguide"), React.createElement(LazyGameGuide, {
        branding: branding,
        matchId: matchId
      }));
    }
  }), React.createElement(Route, {
    path: oddsPaths,
    render: _ref8 => {
      let match = _ref8.match;
      return React.createElement(TipsenModal, {
        Bottom: () => React.createElement(ModalFooter, {
          routesMatch: routesMatch
        }),
        isOpen: Boolean(match)
      }, React.createElement(LazyOdds, {
        branding: branding
      }));
    }
  }));
};
setGlobal('svs.components.tipsen.detailViewMobileHandler.DetailViewMobileHandler', DetailViewMobileHandler);

 })(window);